import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const authHeaders = () => {
  const raw = localStorage.getItem("userDetails");
  const token = raw ? JSON.parse(raw)?.token : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// POST /api/equipment — create a new equipment log entry
export const createEquipementApi = (data) =>
  axios.post(`${API_BASE_URL}/api/equipment`, data, {
    headers: authHeaders(),
  });

// GET /api/equipment/list — historical log list (used by fetchEquipmentList thunk)
export const getEquipementListApi = () =>
  axios.get(`${API_BASE_URL}/api/equipment/list`, {
    headers: authHeaders(),
  });

// POST /api/equipment/:id/service — append a service record
export const logServiceApi = (id, data) =>
  axios.post(`${API_BASE_URL}/api/equipment/${id}/service`, data, {
    headers: authHeaders(),
  });

// POST /api/equipment/:id/relocate — relocate equipment to a new project
export const relocateEquipmentApi = (id, data) =>
  axios.post(`${API_BASE_URL}/api/equipment/${id}/relocate`, data, {
    headers: authHeaders(),
  });

// PATCH /api/equipment/:id/status — toggle equipment active status
export const toggleEquipmentStatusApi = (id, eqpStatus) =>
  axios.patch(`${API_BASE_URL}/api/equipment/${id}/status`, { eqpStatus }, {
    headers: authHeaders(),
  });

// POST /api/vehicle/:id/service — log a vehicle service to Finance only
export const logVehicleServiceApi = (id, data) =>
  axios.post(`${API_BASE_URL}/api/vehicle/${id}/service`, data, {
    headers: authHeaders(),
  });
